import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Search, Plus, MessageSquare, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/", label: "Ana Sayfa", icon: Home, match: (p) => p === "/" },
  { to: "/ilanlar", label: "Ara", icon: Search, match: (p) => p.startsWith("/ilanlar") },
  { to: "/panel/yeni-ilan", label: "İlan Ver", icon: Plus, center: true, auth: true },
  { to: "/panel/mesajlar", label: "Mesajlar", icon: MessageSquare, auth: true, match: (p) => p.startsWith("/panel/mesajlar") },
  { to: "/panel", label: "Hesabım", icon: User, auth: true, match: (p) => p === "/panel" },
];

export function MobileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const go = (item) => (e) => {
    if (item.auth && !user) {
      e.preventDefault();
      navigate("/giris");
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white pb-safe lg:hidden">
      <div className="mx-auto flex max-w-md items-end justify-around px-2">
        {ITEMS.map((item) => {
          const active = item.match ? item.match(location.pathname) : false;
          const Icon = item.icon;
          if (item.center) {
            return (
              <Link key={item.to} to={item.to} onClick={go(item)} data-testid="mobilenav-create"
                className="-mt-5 flex flex-col items-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-600 text-white shadow-lg shadow-emerald-600/30">
                  <Icon size={24} />
                </span>
                <span className="mt-0.5 text-[10px] font-semibold text-emerald-700">{item.label}</span>
              </Link>
            );
          }
          return (
            <Link key={item.to} to={item.to} onClick={go(item)} data-testid={`mobilenav-${item.label}`}
              className={cn("flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 py-2",
                active ? "text-emerald-700" : "text-slate-500")}>
              <Icon size={22} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
